/**
 * @author Ariel
 * @description 岗位新增编辑页面
 * @Date 2020/1/2
 */
import React from 'react';
import { connect } from 'dva';
import { framework_tool, component_tool,utils_tool } from '@/tool'
import { PositionSelectOrgList } from './positionSelectOrgList'
let { WizContainer, modelUtils } = framework_tool;
let { WizCard, WizForm, WizSpin } = component_tool;
let { Session } = utils_tool

class PositionDetail extends WizContainer {

  componentName = 'positionDetail';

  constructor(props) {
    super(props);
    const { history } = props;
    let initialValue = {};
    let positionState = 1;
    let cardTitle = '新增'
    if (history.location && history.location.pathname === '/org/position/positionDetailUpd') {
      if(history.location && history.location.record){
        initialValue = history.location.record;
        positionState = initialValue.state;
        Session.set('positionDetailUpd',initialValue)
        Session.set('positionState',positionState)
      }else{
        initialValue = Session.get('positionDetailUpd') || {};
        positionState = Session.get('positionState') || 1;
      }
      cardTitle = '编辑'
    }
    this.state = {
      cardTitle,
      name: null
    }
    this.positionState = positionState;
    this.initialValue = initialValue;
  }

  _componentDidMount() {
    const { history } = this.props;
    this.doActions([
      {
        path: 'positionCategory/getPositionCategoryList', //获取岗位分类列表
        payload: {
          key: 'positionCategory_getPositionCategoryList',
          apiParams: {
            type: 'FOLDER'
          }
        },
        requireLoading: true,
      }
    ])
  }

  propsAndStateOnChange = {
    addPosition: this._addPositionOver.bind(this),
    positionCategoryList: this.positionCategoryListOnChange.bind(this)
  }

  positionCategoryListOnChange(nextProps, nextState) {
    let _list = [];
    if (nextProps['positionCategoryList'] && nextProps['positionCategoryList']['success'] === true) {
      let list = nextProps["positionCategoryList"]['data']
      list && list.forEach(val => {
        _list.push({ code: val['id'], codeName: val['name'] })
      });
      nextState['positionCategoryList'] = _list;
      return true;
    } else {
      wizNotice.error(nextProps["positionCategoryList"]['msg'])
      return false;
    }
  }

  /**
   * 岗位变动成功返回原页面，失败弹出提示
   */
  _addPositionOver(nextProps, nextState) {
    if (nextProps.addPosition.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/org/position');
    } else {
      wizNotice.error('提交失败：' + nextProps.addPosition.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        if(key === 'orgIds'){
          let _ids = []
          value && value.forEach(v => {
            _ids.push(v['id'])
          });
          fitterValues[key] = _ids;
        }else{
          fitterValues[key] = value;
        }
      }
    });
    return fitterValues;
  }

  /**
   * 保存/更新 岗位信息
   * @param values
   * @private
   */
  _savePosition(values) {
    const { history } = this.props;
    let apiPath = "position/add";
    if (history.location && history.location.pathname === '/org/position/positionDetailUpd') {
      apiPath = "position/update"
    }
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: "addPosition",
        apiParams: {
          ...fitterValues
        }
      }
    });
  }

  _render() {
    const { positionCategoryLoading } = this.props;
    let { cardTitle, positionCategoryList } = this.state;
    let columns = [
      {
        formItem: {
          type: "hidden",
          initialValue: this.initialValue.id
        },
        name: "id"
      },
      {
        title: "岗位名称",
        name: "name",
        formItem: {
          maxlength: 20,
          placeholder: '岗位名称最多输入20个字',
          rules: [
            {
              required: true,
              message: '请输入岗位名称'
            },
            {
              pattern: /^[^\s]*$/,
              message: '岗位名称录入信息不能包含空格'
            }
          ],
          initialValue: this.initialValue.name
        }
      },
      {
        title: "岗位编码",
        name: "code",
        formItem: {
          maxlength: 50,
          placeholder: '仅支持数字、字母、-、_',
          rules: [
            {
              required: true,
              message: '请输入岗位编码'
            },
            {
              pattern: /^[A-Za-z0-9-_]+$/,
              message: '岗位编码仅支持数字、字母、-、_'
            }
          ],
          initialValue: this.initialValue.code
        }
      },
      {
        title: "岗位分类",
        name: "positionCategoryIds",
        dataIndex: "positionCategoryId",
        dict: positionCategoryList || [],
        formItem: {
          type: "select",
          mode: 'multiple',
          rules: [{
            required: true,
            message: '请选择岗位分类',
          }],
          initialValue: this.initialValue.positionCategoryIds
        }
      },
      {
        title: "状态",
        name: "state",
        dataIndex: "state",
        tableItem: {},
        dict: [
          { code: 1, codeName: '有效' },
          { code: 0, codeName: '无效' }
        ],
        formItem: {
          initialValue: this.positionState,
          type: 'radio',
        }
      },
      {
        title: '所属组织',
        name: 'orgIds',
        formItem: {
          type: 'diy',
          modal: true,
          initialValue: this.initialValue.orgList,
          diy: PositionSelectOrgList,
          rules: [
            {
              required: true,
              message: '请选择组织'
            }
          ]
        }
      }
    ]

    let onSubmit = this._savePosition.bind(this);

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return (
      <WizCard>
        <WizSpin tip={'加载中'} spinning={positionCategoryLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { position, positionCategory } = state;
  const positionCategoryList = modelUtils.getModelEntity(positionCategory, "positionCategory_getPositionCategoryList");
  const addPosition = modelUtils.getModelEntity(position, "addPosition");
  const load = modelUtils.getLoadingState(state, 'positionCategory');
  return {
    positionCategoryList: positionCategoryList,
    addPosition: addPosition,
    ...load
  }
};

export default connect(mapStateToProps)(PositionDetail);
